import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { Form, Input, Modal, Select } from "antd";
import ProjectStore from "../../../../stores/Admin/ProjectStore";
import UserStore from "../../../../stores/Admin/UserStore";
import AppStore from "../../../../stores/User/AppStore";
const { Option } = Select;
const { TextArea } = Input;
export interface ProjectAddDialogProps {
  visible: boolean;
  close: () => void;
}

const ProjectAddDialog: React.FC<ProjectAddDialogProps> = (props) => {
  const [form] = Form.useForm();
  const { otherTag, industryTag } = AppStore;
  useEffect(() => {
    form.resetFields();
  }, [props.visible]);

  const submit = () => {
    const { name, details, otherTagList, industryTag, sort } = form.getFieldsValue();
    console.log(form.getFieldsValue());
    if (!name?.trim()) return;

    ProjectStore.addProject(name, details, otherTagList, industryTag, sort === undefined ? undefined : +sort);
    props.close();
  };

  return (
    <Modal
      title="新增项目"
      visible={props.visible}
      onCancel={props.close}
      onOk={submit}
      okText="确认"
      cancelText="取消"
    >
      <Form form={form}>
        <Form.Item label="项目名称" name="name" rules={[{ required: true, message: "名称不能为空" }]}>
          <Input placeholder="请输入项目名称" />
        </Form.Item>
        <Form.Item label="项目描述" name="details">
          <TextArea rows={4} placeholder="输入项目描述" maxLength={200} showCount />
        </Form.Item>
        <Form.Item label="行业标签" name="industryTag">
          <Select
            size="middle"
            allowClear
            placeholder="请选择行业标签"
            key={AppStore.industryTag.map((item) => item.id)[0]}
            // onChange={handleChange}
            style={{ width: "100%" }}
          >
            {AppStore.industryTag.map((item) => (
              <Option key={item.id}>{item.name} </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="其他标签" name="otherTagList">
          <Select
            mode="multiple"
            size="middle"
            placeholder="请选择其他标签"
            key={AppStore.otherTag.map((item) => item.id)[0]}
            // onChange={handleChange}
            style={{ width: "100%" }}
          >
            {AppStore.otherTag.map((item) => (
              <Option key={item.id}>{item.name} </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="排序权重（升序）" name="sort">
          <Input type="number" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default observer(ProjectAddDialog);
